import React from 'react';
import { LOGO_URL } from '../common/constants';

const LogoDisplay = ({ className, alt = "Arboleda Logo" }) => {
  const handleError = (e) => {
    // Si la carga directa falla, intentamos usar un proxy para saltar las restricciones de CORS
    if (!e.target.dataset.retried) {
      e.target.dataset.retried = 'true';
      e.target.src = `https://api.allorigins.win/raw?url=${encodeURIComponent(LOGO_URL)}`;
    } else if (!e.target.dataset.failed) {
      // Si el proxy también falla, usamos un placeholder como último recurso
      e.target.dataset.failed = 'true';
      e.target.src = 'https://placehold.co/400x400?text=Arboleda';
    }
  };

  return (
    <img
      src={LOGO_URL}
      alt={alt}
      className={className}
      referrerPolicy="no-referrer"
      onError={handleError}
    />
  );
};

export default LogoDisplay;